/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authManageModeration.defs.js'
export * as $defs from './authManageModeration.defs.js'
